var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "container"
  }, [_c("div", {
    staticClass: "titleBar"
  }, [_c("div", {
    staticClass: "img-wrap",
    on: {
      click: _vm.back
    }
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/arrow.png"),
      alt: ""
    }
  })]), _c("div", {
    staticClass: "btn",
    on: {
      click: _vm.publish
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("Post")) + " ")])]), _c("div", {
    staticClass: "upload-con"
  }, [_c("div", {
    staticClass: "upload"
  }, [_vm.opacity == 0 ? _c("div", {
    staticClass: "text-con"
  }, [_c("img", {
    attrs: {
      src: require("../../assets/images/Add.png"),
      alt: ""
    }
  }), _c("span", {
    staticClass: "text"
  }, [_vm._v("Add Cover Image")]), _c("span", {
    staticClass: "tip"
  }, [_vm._v("（No less than1080*960px）")])]) : _vm._e(), _vm.type === "1" ? _c("van-uploader", {
    style: "opacity:" + _vm.opacity,
    attrs: {
      "max-size": 5 * 1024 * 1024,
      accept: "image/gif, image/jpeg, image/png",
      "after-read": _vm.afterRead,
      multiple: "",
      "max-count": 1
    },
    on: {
      oversize: _vm.onOversize,
      delete: _vm.del
    },
    model: {
      value: _vm.fileList,
      callback: function callback($$v) {
        _vm.fileList = $$v;
      },
      expression: "fileList"
    }
  }) : _vm._e(), _vm.type === "2" ? _c("van-uploader", {
    style: "opacity:" + _vm.opacity,
    attrs: {
      "max-size": 250 * 1024 * 1024,
      accept: "video/*",
      "after-read": _vm.afterRead,
      multiple: "",
      "max-count": 1
    },
    on: {
      oversize: _vm.onOversize,
      delete: _vm.del
    },
    model: {
      value: _vm.fileList,
      callback: function callback($$v) {
        _vm.fileList = $$v;
      },
      expression: "fileList"
    }
  }) : _vm._e()], 1)]), _c("div", {
    staticClass: "bottom"
  }, [_c("input", {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.title,
      expression: "title"
    }],
    attrs: {
      type: "text",
      placeholder: "Enter Title"
    },
    domProps: {
      value: _vm.title
    },
    on: {
      input: function input($event) {
        if ($event.target.composing) return;
        _vm.title = $event.target.value;
      }
    }
  })]), _c("div", {
    staticClass: "ctn"
  }, [_c("vue-html5-editor", {
    staticClass: "editor",
    attrs: {
      placeholder: _vm.$t("Pstswy"),
      content: _vm.content,
      "show-module-name": ""
    },
    on: {
      change: _vm.updateData
    }
  })], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };